import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { router } from '~/router';
import Marker from 'Components/Maps/Marker';
import PropTypes from 'prop-types';
import React from 'react';
import formatTimestamp from 'utils/formatTimestamp';

// Styled Components
const StyledPaper = styled(Paper)(({ theme }) => ({
    width: '100%',
    marginTop: theme.spacing(1),
    overflowX: 'auto'
}));

const StyledTable = styled(Table)({
    minWidth: 150
});

const StyledTableRow = styled(TableRow)({
    height: 38
});

const StyledTableCell = styled(TableCell)({
    fontWeight: 'bold'
});

const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.background.default,
    fontWeight: 'bold'
}));

const StyledTooltipContainer = styled('div')({
    margin: 2,
    width: '100%'
});

const StyledHeader = styled('div')({
    marginBottom: 5
});

// DevicesTable Component
const DevicesTable = ({ site }) => {
    if (site.devices.length === 0) {
        return <div>No devices available</div>;
    }

    return (
        <StyledPaper>
            <StyledTable padding="dense">
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell>Device Name</StyledTableCell>
                        <StyledTableCell>Status</StyledTableCell>
                        <StyledTableCell>Last Status Change</StyledTableCell>
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {site.devices.map(device => (
                        <StyledTableRow key={device.id}>
                            <StyledTableCell>{device.name}</StyledTableCell>
                            <StyledTableCell>{device.status}</StyledTableCell>
                            <StyledTableCell>
                                {formatTimestamp(device.status_updated_at, site.timezone)}
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </StyledTable>
        </StyledPaper>
    );
};

DevicesTable.propTypes = {
    site: PropTypes.object.isRequired
};

const getTooltip = site => (
    <StyledTooltipContainer>
        <StyledHeader>
            <StyledTypography>{site.name}</StyledTypography>
        </StyledHeader>
        <DevicesTable site={site}/>
    </StyledTooltipContainer>
);

const onClick = siteId => () => router.navigate(`/sites/${siteId}`);

const Component = ({ position, site, tooltipID, tooltipMutex, handleSetTooltipMutex }) => {
    return <Marker
        handleSetTooltipMutex={handleSetTooltipMutex}
        onClick={onClick(site.id)}
        position={position}
        status={site.status}
        tooltip={getTooltip(site)}
        tooltipID={tooltipID}
        tooltipMutex={tooltipMutex}
    />;
};

Component.propTypes = {
    site: PropTypes.object.isRequired,
    position: PropTypes.object.isRequired,
    tooltipID: PropTypes.number,
    tooltipMutex: PropTypes.number,
    handleSetTooltipMutex: PropTypes.func
};

export default Component;
